import api from "./api";


export const getPrognosisSolarNext = async (budget?: string, plant?: string) => {
    const response = await api.get(`prognosis/listOneSolarNext?budget=${budget ? budget : ""}&idPlant=${plant ? plant : ""}`,);
    return response.data;
};
